import { FormGroup, Input, Col } from "reactstrap";
import InputField from "./InputField";
import SelectField from "./SelectField";
import { LabelText } from "./Input";
import CommonDateTimePicker from "./CommonDateTimePicker";
import moment from "moment";
import { CreatableSelectField } from "./CreatableSelectField";

export const RenderField = ({
  field,
  handleChange,
  handleBlur,
  logoFile,
  profile,
  imageOn,
  handleFileChange,
  fileInputRef,
  values,
  mandatoryChecked,
  radioValue,
  setRadioValue,
  touched,
  setMandatoryIsChecked,
  setSelectedState,
  errors,
  index,
  setSelectedCountry,
  setFieldTouched,
  setStartDate,
  startDate,
  isAttribute,
  setFieldValue,
  options,
  setIsChecked,
  isChecked,
  setMandatoryIsCheckedSelfcare,
  mandatoryCheckedSelfcare,
  setFieldError,
  isCounter,
  setIsCounter,
  setMandatoryIsCheckedPersistence,
  mandatoryCheckedPersistence,
  isFromBussinessProfileModel,
  useGroupedOptions
}) => {
  const option = Array.isArray(options)
    ? options.find((opt) => opt?.name === field?.name)
    : null;
  const dateFormatCommon = localStorage.getItem("dateFormat") || "DD MMM YYYY";
  const dateFormat = field?.timeFormat ? `${dateFormatCommon} ${field?.timeFormat}` : dateFormatCommon;
  switch (field.type) {
    case "creatable-select":
      return (
        <CreatableSelectField
          values={values[field.name]}
          placeholder={" "}
          handleChange={(value) => {
            setFieldValue(`${field.name}`, value, false);
            setFieldTouched(`${field.name}`, false);
          }}
          className={
            (errors[field.name] && touched[field.name]) || false
              ? field.className
              : ""
          }
          onKeyDown={(event) => {
            const key = event.key;
            const regex = /^[a-zA-Z0-9]$/;
            if (
              regex.test(key) ||
              [
                "Backspace",
                "Delete",
                "ArrowLeft",
                "ArrowRight",
                "Enter",
              ].includes(key)
            ) {
              return;
            }
            event.preventDefault();
          }}
          name={field?.name}
          options={option ? option.options : []}
          isMulti={field?.isMulti}
          fieldLabel={field?.label}
          fieldName={field?.name}
          valuess={values}
          setFieldError={setFieldError}
          setFieldValue={setFieldValue}
          // errors={errors[field.name]}
          touched={touched[field.name]}
          isRVStyle={true}
        />
      );
    case "Selfcare-creatable-select":
      return (
        <CreatableSelectField
          values={values[field.name]}
          placeholder={" "}
          handleChange={(value) => {
            setFieldValue(`${field.name}`, value, false);
            setFieldTouched(`${field.name}`, false);
          }}
          onKeyDown={(event) => {
            const key = event.key;
            const regex = /^[a-zA-Z0-9]$/;
            if (
              regex.test(key) ||
              [
                "Backspace",
                "Delete",
                "ArrowLeft",
                "ArrowRight",
                "Enter",
              ].includes(key)
            ) {
              return;
            }
            event.preventDefault();
          }}
          name={field?.name}
          options={option ? option.options : []}
          isMulti={field?.isMulti}
          fieldLabel={field?.label}
          fieldName={field?.name}
          valuess={values}
          setFieldError={setFieldError}
          isAttribute={isAttribute}
          setFieldValue={setFieldValue}
          // errors={errors[field.name]}
          touched={touched[field.name]}
          isRVStyle={true}
        />
      );
    case "select":
      return (
        <SelectField
          name={
            !field?.insideTable
              ? field.name
              : `${field.arrayName}[${index}][${field.name}]`
          }
          placeholder={" "}
          className={
            !field?.insideTable
              ? (errors[field.name] && touched[field.name]) || false
                ? field.className
                : ""
              : (touched[field.arrayName] &&
                  touched[field.arrayName][index] &&
                  !values[field.arrayName][index][field.name]) ||
                false
              ? field.className
              : ""
          }
          closeMenuOnSelect={field.closeMenuOnSelect}
          value={
            !field?.insideTable
              ? values[field.name]
              : values[field.arrayName] && values[field.arrayName][index]
              ? values[field.arrayName][index][field.name]
              : ""
          }
          handleChange={(value) => {
            if (!field?.insideTable) {
              setFieldValue(`${field.name}`, value, false);
              setFieldTouched(`${field.name}`, false);
              if (field?.isLocation && field.name === "country") {
                setFieldValue("state", "");
                setFieldValue("city", "");
                setSelectedCountry(value);
              }
              if (field?.isLocation && field.name === "state") {
                setFieldValue("city", "");
                setSelectedState(value);
              }
            } else {
              const newArray = [...values[field.arrayName]];
              newArray[index] = {
                ...newArray[index],
                [field.name]: value,
              };
              setFieldValue(field.arrayName, newArray);
              setFieldTouched(field.arrayName, false);
            }
          }}
          isDisabled={field?.disable}
          isMulti={field?.isMulti}
          options={useGroupedOptions ? options : option ? option.options : []}
          isRVStyle={true}
        />
      );
    case "date":
      const value=isFromBussinessProfileModel?moment.utc(values[field.name]):values[field.name]
      return (
        <CommonDateTimePicker
          value={value}
          format={dateFormat}
          name={field.name}
          views={field.views}
          className={`${field?.secondClassName} ${
            errors[field.name] && touched[field.name] ? field?.className : ""
          }`}
          handleChange={(date) => {
            setFieldTouched(field.name, false);
            setFieldValue(field.name, date);
            if (field?.useStateRequired) {
              if (field.indicator === "start") {
                setStartDate(date);
              }
            }
          }}
          style={{
            height: "38px",
            fontSize: "0.875rem",
            borderRadius: "0.5rem",
          }}
          disabled={field?.disable}
          minDate={
            field.minDate
              ? field.indicator === "start"
                ? moment()
                : startDate
              : undefined
          }
          minDateTime={
            !field.minDate
              ? field.indicator === "start"
                ? moment()
                : startDate
              : undefined
          }
        />
      );
    case "radio":
      return (
        <Col sm={12} md={6}>
          <div className="d-flex align-items-center justify-content-between mb-2">
            <LabelText
              classLabelName={"d-block text-black mb-0"}
              displayText={field.label}
              check
            />
            <InputField
              name={field.name}
              value={radioValue}
              handleChange={setRadioValue}
              className={"form-check-input"}
              type={field.type}
              defaultChecked={radioValue}
            />
          </div>
        </Col>
      );
    case "switch":
      if (field.customLayout && field.name === "isBundle") {
        return (
          <div className="custom-switch-container">
            <div className="switch-sub-label mb-2">
              <span className="text-muted rv-sub-label">
                {field.switchLabel}
              </span>
            </div>

            <div className="d-flex align-items-center">
              <span className="me-2">{field.switchSubLabel}</span>
              <FormGroup switch>
                <Input
                  type={field.type}
                  className="rv-form-switch-input"
                  checked={isChecked}
                  onClick={() => {
                    setIsChecked(!isChecked);
                  }}
                  disabled={field?.disable}
                />
              </FormGroup>
            </div>
          </div>
        );
      }

      // Handle existing switch logic for other switches
      return (
        <FormGroup switch>
          <Input
            type={field.type}
            className="rv-form-switch-input"
            checked={
              field.label === "Mandatory"
                ? mandatoryChecked
                : field.label === "Selfcare"
                ? mandatoryCheckedSelfcare
                : field.name === "Counter"
                ? isCounter
                : field.label === "Rated Event Persistence"
                ? mandatoryCheckedPersistence
                : isChecked
            }
            onClick={() => {
              if (field.label === "Mandatory") {
                setMandatoryIsChecked(!mandatoryChecked);
              } else if (field.label === "Selfcare") {
                setMandatoryIsCheckedSelfcare(!mandatoryCheckedSelfcare);
              } else if (field.label === "Rated Event Persistence") {
                setMandatoryIsCheckedPersistence(!mandatoryCheckedPersistence);
              } else if (field.name === "Counter") {
                setIsCounter(!isCounter);
              } else {
                setIsChecked(!isChecked);
              }
            }}
            disabled={field?.disable}
          />
          <LabelText
            htmlFor={field.name}
            displayText={field.switchLabel}
            classLabelName={"rv-sub-label"}
            check
          />
        </FormGroup>
      );
    default:
      return (
        <InputField
          name={
            !field?.insideTable
              ? field.name
              : `${field.arrayName}[${index}][${field.name}]`
          }
          type={field.type}
          className={
            !field?.insideTable
              ? field.className
              : (touched[field.arrayName] &&
                  touched[field.arrayName][index] &&
                  !values[field.arrayName][index][field.name]) ||
                false
              ? field.className
              : ""
          }
          id={field.id}
          disabled={field?.disable}
          pattern={field.pattern}
          handleChange={handleChange}
          handleBlur={handleBlur}
          value={
            !field?.insideTable
              ? values[field.name]
              : values[field.arrayName] && values[field.arrayName][index]
              ? values[field.arrayName][index][field.name]
              : ""
          }
          invalid={
            !field?.insideTable
              ? touched[field.name] && errors[field.name]
                ? true
                : false
              : errors[field.arrayName] &&
                errors[field.arrayName][index] &&
                touched[field.arrayName] &&
                touched[field.arrayName][index] &&
                touched[field.arrayName][index][field.name]
              ? true
              : false
          }
        />
      );
  }
};
